// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
// import * as React from "react"; // Starter Custom Code
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useContext, useEffect } from "react";
/* Starter Custom Code - End */

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    // Starter Custom Code
    spacerColumnGridItem?: GridItemProps;
    mobileHeading?: InjectableCss;
    desktopHeading?: InjectableCss;
}

export const viewStyles: ProductDetailsViewStyles = {
    container: {
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([30, null, 40, 60, 30]))}
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 6, 6, 5],
    },
    rightColumnGridItem: {
        width: [12, 12, 6, 6, 4],
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    spacerColumnGridItem: { width: [0, 0, 0, 0, 1] },
    mobileHeading: {
        css: css`
            ${spacingStyles(null, pxToRem(20))}

            ${breakpoint("md")} {
                display: none;
            }
        `,
    },
    desktopHeading: {
        css: css`
            ${x => spacingStyles(null, x.theme.design.product.detail.contentSpacing)}
            display: none;
            width: 100%;

            ${breakpoint("md")} {
                display: block;
            }
        `,
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<WidgetProps> = props => {
    /* Starter Custom Code - Start */
    const trackViewItem = ga.use.trackViewItem();
    const productId = useContext(ProductContext).product.id;

    useEffect(() => {
        trackViewItem();
    }, [productId]);

    return (
        <>
            <StyledWrapper {...styles.mobileHeading}>
                <Zone contentId={props.id} zoneName="Heading" />
            </StyledWrapper>
            <GridContainer {...styles.container}>
                <GridItem {...styles.spacerColumnGridItem}></GridItem>
                <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                    <Zone contentId={props.id} zoneName="Content0" />
                </GridItem>
                <GridItem {...styles.spacerColumnGridItem}></GridItem>
                <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                    <StyledWrapper {...styles.desktopHeading}>
                        <Zone contentId={props.id} zoneName="Heading" />
                    </StyledWrapper>
                    <Zone contentId={props.id} zoneName="Content1" />
                </GridItem>
                <GridItem {...styles.spacerColumnGridItem}></GridItem>
            </GridContainer>
        </>
    );
    /* Starter Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
